/*
 * action types
 */

export const ADD_CHAT_MESSAGE = 'ADD_CHAT_MESSAGE'
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES'
export const SET_CARDS = 'SET_CARDS'
export const SET_CARDS_IN_THE_MIDDLE = 'SET_CARDS_IN_THE_MIDDLE'
export const SET_PREVIOUS_TAKER = 'SET_PREVIOUS_TAKER'
export const SET_CURRENT_PLAYER = 'SET_CURRENT_PLAYER'
export const SET_AVAILABLE_HANDS = 'SET_AVAILABLE_HANDS'
export const SET_CURRENT_HAND = 'SET_CURRENT_HAND'
export const SET_SCORES = 'SET_SCORES'
export const SET_PLAYERS = 'SET_PLAYERS'
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL'
export const LOGOUT = 'LOGOUT'
export const SET_PUNISHMENTS = 'SET_PUNISHMENTS'
export const SET_SINGLE_PLAYER = 'SET_SINGLE_PLAYER'
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS'
export const SET_GAME_MODE = 'SET_GAME_MODE'
export const SET_DEEPLINK_DATA = 'SET_DEEPLINK_DATA'


/*
 * action creators
 */

export function addChatMessage(message) {
    return { type: ADD_CHAT_MESSAGE, message }
}

export function setChatMessages(messages) {
    return { type: SET_CHAT_MESSAGES, messages }
}

export function setCards(text) {
    return { type: SET_CARDS, text }
}

export function setScores(text) {
    return { type: SET_SCORES, text }
}

export function setPlayers(text) {
    return { type: SET_PLAYERS, text }
}

export function setAvailableHands(text) {
    return { type: SET_AVAILABLE_HANDS, text }
}

export function setCardsInTheMiddle(text) {
    return { type: SET_CARDS_IN_THE_MIDDLE, text }
}

export function setPreviousTaker(text) {
    return { type: SET_PREVIOUS_TAKER, text }
}

export function setCurrentPlayer(text) {
    return { type: SET_CURRENT_PLAYER, text }
}

export function setCurrentHand(text) {
    return { type: SET_CURRENT_HAND, text }
}


export function setPunishments(filter) {
    return { type: SET_PUNISHMENTS, filter }
}

export function setSinglePlayer(singlePlayer) {
    return { type: SET_SINGLE_PLAYER, singlePlayer }
}

export function setAuthStatus(isAuthenticated, authType) {
    return { type: SET_AUTH_STATUS, isAuthenticated, authType }
}

export function setGameMode(gameMode) {
    return { type: SET_GAME_MODE, gameMode }
}

export function setDeeplinkData(roomId, inviteCode) {
    return { type: SET_DEEPLINK_DATA, roomId, inviteCode }
}